import {MI} from "../init";
import GameWinlines from "./GameWinlines";
import CoinsEmitter from "./CoinsEmitter";

/**
 * @constructor
 * @returns {GameAssets}
 */
export default function GameAssets() {

    /** @type {MadnesObject} */
    this.bg;

    /** @type {MadnesObject} */
    this.bgBonus;

    /** @type {GameHeader} */
    this.header;

    /** @type {MadnesGraphics} */
    this._blackScreen;

    this._blackScreenAlpha = 0.65;

    /** @type {Array<MadnesObject>} */
    this._particles = [];

    /** @type {AnimsWinCounter} */
    this.animWinCounter;

    /** @type {GameWinlines} */
    this._winLines;

    /** @type {CoinsEmitter} */
    this.coinsEmitter;

    /** @type {MadnesGroup} */
    this._lightCoverGroup;

    /** @type {MadnesObject} */
    this._ligthCoverTop;

    /** @type {MadnesObject} */
    this._ligthCoverBottom;

    /** @type {MadnesObject} */
    this._ligthCoverLeft;

    /** @type {MadnesObject} */
    this._ligthCoverRight;

    /** @type {MadnesTween|null} */
    this._lightCoverTween = null;

    /** @type {MadnesTween|null} */
    this._lightCoverPulseTween;

    this._lightCoverPulseStopped = false;

    /** @type {AnimsBigWinCounter} */
    this.bigWin;

    /** @type {AnimsBoomSpins} */
    this.boomSpins;
};

GameAssets.prototype.createBlackScreen = function() {
    this._blackScreen = MI.addGraphics(0, 0);
    this._blackScreen.beginFill(0x000000);
    this._blackScreen.drawRectangle(50, 0, MI.getWi() - 50, MI.getHe() - 70);
    this._blackScreen.setAlpha(0);
    this._blackScreen.setVisible(false);
};

GameAssets.prototype.fadeInBlackScreen = function() {

    var _self = this;

    return new Promise(function(res) {

        if(_self._blackScreen.getAlpha() === 1) {
            res();
            return;
        }

//		_self._blackScreen.setAlpha(0);
        _self._blackScreen.setVisible(true);

        MI.addTween().to(_self._blackScreen, { 'alpha': _self._blackScreenAlpha }, {
            'duration': 150,
            'callback': function() {
                res();
            }
        });
    });
};

GameAssets.prototype.fadeOutBlackScreen = function() {

    var _self = this;

    return new Promise(function(res) {

        MI.addTween().to(_self._blackScreen, { 'alpha': 0 }, {
            'duration': 200,
            'callback': function() {
                _self._blackScreen.setVisible(false);
                res();
            }
        });
    });
};

GameAssets.prototype.createParticles = function() {
    for(var i = 0; i < 12; i++) {
        var particles = MI.addImg(-9999, -9999, "particles_atlas");
        particles.createAnims();
        particles.setVisible(false);
        particles.anims.add("anim", MI.generateFrameNames("particles_", 0, 34, "", 5));
        particles.anims.addOnComplete(function() {

            this.setVisible(false);
        });
        particles.setScale(2, 2);

        particles.setAnchor(0.5, 0.5);
        this._particles.push(particles);
    }
};

/**
 * @param {Array<MadnesObject>} symbols
 * @param {number=} delay
 * @param {GameGroups=} groups
 */
GameAssets.prototype.playParticles = function(symbols, delay, groups) {

    delay = typeof delay !== "undefined" ? delay : 80;

    var _self = this;
    var j = 0;

    if(groups && !groups.get("group_symbols_anims_0").getVisible()) {
        j++;
    }

    for(var i = 0; i < symbols.length; i++) {

        var reelX = symbols[i].getReelX();

        if(groups && !groups.get("group_symbols_anims_" + reelX).getVisible()) {
            continue;
        }

        (function(i) {

            MI.createTimer().add(function() {
                _self._particles[i].setPos(symbols[i].getPosX(), symbols[i].getPosY(), true);
                _self._particles[i].anims.stop();
                _self._particles[i].anims.play("anim");
                _self._particles[i].setVisible(true);
            }, (symbols[i].getReelX() - j) * delay);

        } (i));
    }
};

/**
 * @param {GameConfig} gameConfig
 * @param {GameGroups} groups
 */
GameAssets.prototype.createWinLines = function(gameConfig, groups) {
    groups.create("group_winlines");
    this._winLines = new GameWinlines(gameConfig, groups);
    this._winLines.create();
};

/**
 * @param {Array<ServerResultWinline>} lineWins
 */
GameAssets.prototype.animWinLines = function(lineWins) {
    this._winLines.animWinlines(lineWins);
};

GameAssets.prototype.hideWinLines = function() {
    this._winLines.hideWinlines();
};

/** @param {GameGroups} groups */
GameAssets.prototype.createCoinsEmitter = function(groups) {
    this.coinsEmitter = new CoinsEmitter();
    this.coinsEmitter.create(groups);
};

/**
 * @param {GameGroups} gameGroups
 */
GameAssets.prototype.createLightCover = function(gameGroups) {

    this._ligthCoverTop = MI.addImg(0, 0, "reels_atlas").setFrameName("win-frame_top");
    this._ligthCoverLeft = MI.addImg(0, 110, "reels_atlas").setFrameName("win-frame_left");
    this._ligthCoverRight = MI.addImg(MI.getWi(), 110, "reels_atlas").setFrameName("win-frame_right").setAnchor(1, 0);
    this._ligthCoverBottom = MI.addImg(0, MI.getHe(), "reels_atlas").setFrameName("win-frame_bottom").setAnchor(0, 1);

    this._lightCoverGroup = gameGroups.create("group_light_cover");
    this._lightCoverGroup.add(this._ligthCoverTop);
    this._lightCoverGroup.add(this._ligthCoverLeft);
    this._lightCoverGroup.add(this._ligthCoverRight);
    this._lightCoverGroup.add(this._ligthCoverBottom);

    this._lightCoverGroup.setVisible(false);
};

GameAssets.prototype.lightCoverFadeIn = function() {
    var _self = this;

    this._lightCoverGroup.setVisible(true);
    this._lightCoverGroup.setAlpha(0);

    this._lightCoverTween && this._lightCoverTween.stop();

    this._lightCoverTween = MI.addTween().to(this._lightCoverGroup, { 'alpha': 1 }, {
        'duration': 120,
        'callback': function() {
            _self._lightCoverTween = null;
        }
    });
};

GameAssets.prototype.lightCoverFadeOut = function() {

    var _self = this;

    this._lightCoverTween && this._lightCoverTween.stop();

    this._lightCoverTween = MI.addTween().to(this._lightCoverGroup, { 'alpha': 0 }, {
        'duration': 120,
        'callback': function() {
            _self._lightCoverGroup.setVisible(false);
            _self._lightCoverTween = null;
        }
    });
};

GameAssets.prototype.lightCoverPulse = function() {

    var _self = this;

    this._lightCoverGroup.setVisible(true);
    this._lightCoverGroup.setAlpha(0);

    this._lightCoverPulseStopped = false;

    this._lightCoverPulseTween = MI.addTween().to(this._lightCoverGroup, { 'alpha': 1 }, {
        'duration': 250,
        'yoyo': true,
        'count': -1,
        'onLoop': function() {

            if(_self._lightCoverPulseStopped) {
                _self._lightCoverPulseTween.stop();
                _self._lightCoverPulseTween = null;

                _self.lightCoverFadeOut();
            }
        }
    });
};

GameAssets.prototype.lightCoverPulseStop = function() {
    this._lightCoverPulseStopped = true;
};